<template>
  <a-layout class="layout">
    <a-layout-header>
      <div class="logo">火山监测系统</div>
    </a-layout-header>
    <a-layout-content>
      <router-view></router-view>
    </a-layout-content>
    <a-layout-footer style="text-align: center">
      Volcano Monitor ©2024
    </a-layout-footer>
  </a-layout>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'App'
});
</script>

<style>
.layout {
  min-height: 100vh;
}
.logo {
  color: white;
  font-size: 20px;
  font-weight: bold;
}
</style>
